import api from "../../ApiConfig";
import { Apis } from "../../../config";
import { NotificationManager } from "react-notifications";

// ✅ GET ALL TICKETS (ADMIN)
const getAllTickets = async () => {
  try {
    let result = await api.get(Apis.GetAllTickets);

    if (result.data && result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// ✅ GET SINGLE TICKET WITH MESSAGES
const getTicketById = async (ticketId) => {
  try {
    const result = await api.post(Apis.GetTicketById, { ticketId });

    if (result.data && result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    return result.data.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// ✅ UPDATE TICKET STATUS
const updateTicketStatus = async (data) => {
  try {
    let result = await api.put(Apis.UpdateTicketStatus, data);

    if (result.data && result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    NotificationManager.success("Ticket status updated");
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// ✅ SEND ADMIN / CUSTOMER REPLY
const sendTicketReply = async (formData) => {
  try {
    let result = await api.post(Apis.SendTicketReply, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (result.data && result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    return result.data;
  } catch (error) {
    console.log(error);
    NotificationManager.error("Failed to send message");
    return null;
  }
};

export default {
  getAllTickets,
  getTicketById,
  updateTicketStatus,
  sendTicketReply,
};


// WEBPACK FOOTER //
// ./src/components/services/GetTicketDetails/index.js